import React from "react";
import PropTypes from "prop-types";
import PuzzleCardBase from "../puzzles/common/components/PuzzleCardBase";
import SlidingService from "../puzzles/sliding/SlidingService";
import {
    getSlidingCardContentPadding,
    getSlidingNavigationPath,
    getSlidingPlayData,
    getSlidingProgress,
    getSlidingWordCount,
} from "../puzzles/common/utils/PuzzleCardHelpers";

/**
 * Same shell as {@link CrossCard} — share Play button styling, lock + disable for Standard-only when anonymous / Free plan.
 */
export default function SlidingCard(props) {
    return (
        <PuzzleCardBase
            {...props}
            forceUnlock
            service={SlidingService}
            getProgress={getSlidingProgress}
            getPlayData={getSlidingPlayData}
            getWordCount={getSlidingWordCount}
            getNavigationPath={getSlidingNavigationPath}
            getCardContentPadding={getSlidingCardContentPadding}
        />
    );
}

SlidingCard.propTypes = {
    puzzle: PropTypes.object.isRequired,
    userPayPlan: PropTypes.string,
    subscriptionStatus: PropTypes.string,
    onPlayClick: PropTypes.func,
    buttonText: PropTypes.string,
    isInProgress: PropTypes.bool,
    forceUnlock: PropTypes.bool,
    hideWordCountChip: PropTypes.bool,
    belowDifficultySlot: PropTypes.node,
    browseStoriesChrome: PropTypes.bool,
    hideClusteredBubbles: PropTypes.bool,
    hideTierBadges: PropTypes.bool,
    primaryActionReplacement: PropTypes.node,
    topBadgesOffsetY: PropTypes.number,
};
